import {
  firebaseFire as Libfirebase,
} from '../helpers/firebase-config.js';
import { getLoggedInUser } from "../helpers/authUtils";
import moment from 'moment';


export const StatusAgendaEnum = [
  {
    id: 0,
    desc: 'Aguardando',
    cor: '#FAF9DE'
  },
  {
    id: 1,
    desc: 'Atendimento Iniciado',
    cor: '#CEFAD9'
  },
  {
    id: 2,
    desc: 'Atendimento Finalizado',
    cor: '#D1DBFA'
  },
  {
    id: 3,
    desc: 'Re-agendado',
    cor: '#FAD8CB'
  },
];
//passar a descrição do status para pegar o objeto enum
export const getStatusAgendaENUM = (statusDESC, getByDesc = true) => {
  let st = StatusAgendaEnum.filter(x => (getByDesc && x.desc === statusDESC) || x.id === statusDESC);
  return st.length > 0 ? st[0] : null;
}

export const StatusAgendamentoEnum = [
  {
    id: 0,
    desc: 'Aguardando',
    cor: '#FAF9DE',
    borda: '#fff200'
  },
  {
    id: 1,
    desc: 'Disponível',
    cor: '#CEFAD9',
    borda: '#00ea3a'
  },
  {
    id: 2,
    desc: 'Fila de Espera',
    cor: '#CEFAD9',
    borda: '#C2DEFA'
  },
  {
    id: 3,
    desc: 'Em Atendimento',
    cor: '#D1DBFA',
    borda: '#1e56ff'
  },
  {
    id: 4,
    desc: 'Atendimento Concluído',
    cor: '#D1DBFA',
    borda: '#838DBA'
  },
  {
    id: 5,
    desc: 'Atendimento Não Realizado',
    cor: '#FAD8CB',
    borda: '#ff4300'
  },

];
//passar a descrição do status para pegar o objeto enum
export const getStatusAgendamentoENUM = (statusDESC, getByDesc = true) => {
  let st = StatusAgendamentoEnum.filter(x => (getByDesc && x.desc === statusDESC) || x.id === statusDESC);
  return st.length > 0 ? st[0] : null;
}

export function finalizarAtendimentoConsulta(agendaRef) {
  agendaRef.update({
    status: getStatusAgendaENUM(2, false).desc,
    horario_termino_atendimento: moment().unix() * 1000
  });
}

export async function finalizarAtendimentoPaciente(agendamentoRef, agendaRef, user) {
  try {
    let duracao = "";
    await agendamentoRef.get().then(x => {
      if (x.horario_inicio_atendimento) {
        duracao = moment.utc(moment().diff(moment(x.horario_inicio_atendimento))).format("HH:mm:ss")
      }
    })
    console.log('update at', agendamentoRef.id, {
      horario_termino: moment().unix() * 1000,
      fila: null,
      status: getStatusAgendamentoENUM(4, false).desc,
      user_finalizacao: user,
      duracao
    })
    agendamentoRef.update({
      horario_termino: moment().unix() * 1000,
      fila: null,
      status: getStatusAgendamentoENUM(4, false).desc,
      user_finalizacao: user,
      duracao
    });

    Libfirebase.collection("agendamento")
      .where('agenda', '==', agendaRef)
      .where('ativo', '==', true)
      .get().then(query => {
        query.docs.forEach(doc => {
          if (doc.data().fila != null) {
            doc.ref.update({
              fila: doc.data().fila - 1
            });
          }
        })
      })

    agendaRef.update({
      paciente_atual: null
    });
  } catch (err) {
    console.log("ERRROOO AO FINALIZAR ATENDIMENTO", err);
  }
}

export async function removerPaciente(idAgenda, idPaciente, pacientesLength) {





  await Libfirebase.collection("agendamento")
    .where('agenda', '==', Libfirebase.collection('agenda').doc(idAgenda))
    .where('paciente', '==', Libfirebase.collection('paciente').doc(idPaciente))
    .get().then(query => {
      for (let ref of query.docs) {
        ref.ref.update({
          dataDesativacao: moment().unix() * 1000,
          ativo: false,
          refProfissionalExclusao: Libfirebase.collection('usuarios').doc(getLoggedInUser().cpf),
        });
      }
    })


  Libfirebase.collection("agendamento")
    .where('agenda', '==', Libfirebase.collection('agenda').doc(idAgenda))
    .where('ativo', '==', true)
    .get().then(cont => {

      Libfirebase.collection('agenda').doc(idAgenda).update({
        quantidade_pessoas_inseridas: cont.docs.length
      })
    })
}

export function iniciarAtendimento(agendaRef) {

  agendaRef.update({
    horario_inicio_atendimento: moment().unix() * 1000,
    status: 'Atendimento Iniciado'
  });

  Libfirebase.collection("agendamento")
    .where('agenda', '==', agendaRef)
    .get().then(query => {
      query.docs.forEach(doc => {
        doc.ref.update({
          status: 'Disponível'
        })
      })
    });

}

export function iniciarConsultaPaciente(agendaRef, pacienteRef, agendamentoRef) {
  agendaRef.update({
    'paciente_atual': pacienteRef,
    'status': 'Atendimento Iniciado'
  });
  agendamentoRef.update({
    'horario_inicio': moment().unix() * 1000,
    'status': "Em Atendimento",
  });
}

export function getListAgendamento(agendaId) {
  return new Promise(async function (resolve, reject) {
    Libfirebase.collection("agendamento")
      .where('agenda', '==', Libfirebase.collection("agenda").doc(agendaId))
      .where('ativo', '==', true)
      .onSnapshot((query) => {
        let listAgendamento = [];
        query.forEach((doc) => {
          listAgendamento.push({ ...doc.data(), ref: doc.ref });
        });
        resolve(listAgendamento);
      });
  });
}

export async function getAgendamentosByDate(date) {

  const query = await Libfirebase.collection("agendamento")
    .where('data_consulta', '==', date)
    .where('ativo', '==', true)
    .get()
  return query.docs.map((doc) => {
    return { ...doc.data(), ref: doc.ref };
  });

}

export async function getPacientesByAgenda(agenda) {

  console.log(agenda.path)
  const query = await Libfirebase.collection("agendamento")
    .where('agenda', '==', agenda)
    .where('ativo', '==', true)
    .get()
  return query.docs.map((doc) => {
    return { ...doc.data(), ref: doc.ref };
  });

}

export async function getAgendaByDate(date) {

  const query = await Libfirebase.collection("agenda")
    .where('data_agenda', '==', date)
    .where('ativo', '==', true)
    .get()
  return query.docs.map((doc) => {
    return { ...doc.data(), ref: doc.ref };
  });

}

export function getListAgendaMedico(ref) {
  return new Promise(async function (resolve, reject) {
    if (typeof ref == 'string') {
      ref = Libfirebase.doc(ref);
    }
    await Libfirebase.collection("agenda")
      .where('medico', '==', ref)
      .where('ativo', '==', true)
      .get()
      .then((query) => {
        let listAgenda = [];

        query.forEach((doc) => {

          var data = doc.data();

          data['id'] = doc.id;

          listAgenda.push(data);

        });

        resolve(listAgenda);
      })
      .catch(erro => reject(erro.code));
  });
}

export function getListAgendaMedicoNews(ref) {
  return new Promise(async function (resolve, reject) {
    if (typeof ref == 'string') {
      ref = Libfirebase.doc(ref);
    }

    await Libfirebase.collection("agenda")
      .where('medico', '==', ref)
      .where('ativo', '==', true)
      .where('data_agenda', '>=', moment().format("YYYY-MM-DD"))
      .get()
      .then((query) => {
        let listAgenda = [];

        query.forEach((doc) => {

          var data = doc.data();

          data['id'] = doc.id;

          listAgenda.push(data);

        });

        resolve(listAgenda);
      })
      .catch(erro => {
        console.log(erro)
        reject(erro.code)
      });
  });
}

export function getListAgenda(ref) {
  return new Promise(async function (resolve, reject) {
    await Libfirebase.collection("agenda")
      .where('ativo', '==', true)
      .get()
      .then(async (query) => {
        let listAgenda = [];

        query.forEach(async (doc) => {

          var data = doc.data();

          data['id'] = doc.id;

          data['ref'] = doc.ref;

          if (ref === 1) {
            await doc.data().medico.get().then(datamed => {
              data.medicoDoc = datamed.data();
            })
          }

          listAgenda.push(data);

        });

        resolve(listAgenda);
      })
      .catch(erro => reject(erro.code));
  });
}
//#region CRUD AGENDA
export function deletarAgendamento(idAgenda) {
  Libfirebase.collection("agenda").doc(idAgenda)
    .get().then(async agenda => {
      await Libfirebase.collection("agendamento")
        .where('agenda', '==', agenda.ref)
        .get().then(query => {
          query.docs.forEach(agendamento => {
            if (!agendamento.data()['dataDesativacao'])
              agendamento.ref.update({
                dataDesativacao: moment().unix() * 1000,
                ativo: false,
                refProfissionalExclusao: Libfirebase.collection('usuarios').doc(getLoggedInUser().cpf),
              });
          });
        });
      agenda.ref.update({
        dataDesativacao: moment().unix() * 1000,
        ativo: false,
        refProfissionalExclusao: Libfirebase.collection('usuarios').doc(getLoggedInUser().cpf),
      });
    });
}
export function criarAgenda(data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection("agenda")
      .add(data)
      .then(success => {
        resolve(success);
      })
      .catch(error => reject(error));
  });
}

export function getAgenda(idAgenda, widthData = false) {
  return new Promise(async function (resolve, reject) {
    await Libfirebase.collection("agenda")
      .doc(idAgenda)
      .get()
      .then(async (doc) => {
        if (!widthData) {
          resolve(doc.data());
        }
        else {
          let data = doc.data();
          data.ref = doc.ref;
          await data.medico.get().then(med => {
            data.Medico = med.data()
          });
          resolve(data)
        }
      })
      .catch(erro => reject(erro.code));
  });
}


export function editarAgenda(data, agendaRef) {
  return new Promise(function (resolve, reject) {
    agendaRef
      .update(data)
      .then(success => {
        resolve(success);
      })
      .catch(error => reject(error));
  });
}
//#endregion

//#region Lista de Agendamentos por Paciente
export async function getListAgendaPacienteSnap(ref) {
  return new Promise(async function (resolve, reject) {
    resolve(
      Libfirebase.collection("agendamento")
        .where('ativo', '==', true)
        .where("paciente", "==", ref)
    )
  });
}
export async function formatListAgendaPaciente(list) {
  let listAgenda = [];
  for (let doc of list) {
    let data = doc.data();
    if (data.ativo) {
      data.id = doc.id;
      data.ref = doc.ref;
      await data.agenda.get().then(async (ag) => {
        data.agendaObj = { id: ag.id, ref: ag.ref, ...ag.data() };
        await ag.data().medico.get().then(medico => {
          data.agendaObj.Medico = medico.data();
        })
      });
      listAgenda.push(data);
    }
  }
  return listAgenda;
}
export async function getListAgendaPaciente(ref) {
  return new Promise(async function (resolve, reject) {
    if (typeof ref == 'string') {
      ref = Libfirebase.doc(`paciente/${ref}`);
    }
    await Libfirebase.collection("agendamento")
      .where('ativo', '==', true)
      .where("paciente", "==", ref)
      .get()
      .then(async (query) => {
        resolve(formatListAgendaPaciente(query.docs));
      })
      .catch(erro => reject(erro.code));
  });
}
export async function getAgendamentoReference(refAgenda, refPaciente) {
  return new Promise(async function (resolve, reject) {
    resolve(Libfirebase.collection("agendamento")
      .where("paciente", "==", refPaciente)
      .where("agenda", "==", refAgenda));

  });
}
//#endregion

//#region CRUD AGENDAMENTO
export async function inserirPaciente(idAgenda, idPaciente, pacientesLength, agenda) {
  await Libfirebase.collection('agenda').doc(idAgenda).update({
    quantidade_pessoas_inseridas: pacientesLength
  })

  await Libfirebase.collection("agendamento").add({
    dataCriacao: moment().unix() * 1000,
    agenda: Libfirebase.collection('agenda').doc(idAgenda),
    paciente: Libfirebase.collection('paciente').doc(idPaciente),
    refProfissional: Libfirebase.collection('usuarios').doc(getLoggedInUser().cpf),
    ativo: true,
    data_consulta: agenda.data_agenda,
    hora_inicio: agenda.hora_inicio,
    status: 'Aguardando'
  }).then(v => { })
    .catch(e => console.log("Erro", e));

  Libfirebase.collection('paciente').doc(idPaciente).get().then(doc => {
    var especialidadesList = doc.data().especialidades;

    if (!especialidadesList.includes(agenda.especialidade)) {
      especialidadesList.push(agenda.especialidade)
    }

    doc.ref.update({
      especialidades: especialidadesList
    })

  });

  Libfirebase.collection("agendamento")
    .where('agenda', '==', Libfirebase.collection('agenda').doc(idAgenda))
    .where('ativo', '==', true)
    .get().then(cont => {

      Libfirebase.collection('agenda').doc(idAgenda).update({
        quantidade_pessoas_inseridas: cont.docs.length
      })
    })

}
export function updateAgendamento(ref, data) {
  return new Promise(async function (resolve, reject) {
    await ref.update(data).then(success => {
      resolve(success)
    }).catch(err => {
      reject(err);
    });
  });
}

export async function getUltimoFilaEspera(refAgenda, refPaciente) {
  return new Promise(async function (resolve, reject) {
    let ultimoFila = 0;
    await Libfirebase.collection("agendamento").where("agenda", "==", refAgenda).get().then(async (res) => {
      for (let ag of res.docs) {
        if (ag.data().fila && ag.data().fila > ultimoFila && ag.data().paciente.id != refPaciente.id && ag.data().status === getStatusAgendamentoENUM(2, false).desc)
          ultimoFila = ag.data().fila;
      }
      resolve(ultimoFila);
    }).catch(err => {
      reject(err);
    })
  })
}
//#endregion



export function cancelarAtendimento(agendamentoRef, motivo) {
  agendamentoRef.update({
    status: 3,
    motivo_cancelamento: motivo
  });
}
